export const getSavedFilterModel = (itemName) => {
    // Retrieve the saved filter model from local storage or return a default empty model
    const savedFilter = localStorage.getItem(`dataGridFilterModel_${itemName}`);
    return savedFilter ? JSON.parse(savedFilter) : { items: [] };
};

export const saveFilterModel = (itemName, filterModel) => {
    // Save the filter model to local storage, ensuring it is always structured correctly
    localStorage.setItem(`dataGridFilterModel_${itemName}`, JSON.stringify(filterModel || { items: [] }));
};
